import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const VideoControlsPlayCircle = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
		/>
		<path d="M14 20L20.5 15.872L14 12V20ZM13.0484 9.0978L22.6935 15.2913C22.8978 15.4311 23 15.6247 23 15.872C23 16.1193 22.8978 16.3129 22.6935 16.4526L13.0484 22.6462C12.9409 22.7107 12.8226 22.743 12.6935 22.743C12.5753 22.7537 12.4624 22.7268 12.3548 22.6623C12.2473 22.6086 12.1613 22.5279 12.0968 22.4204C12.0323 22.3129 12 22.1946 12 22.0655V9.67844C12 9.54941 12.0323 9.43113 12.0968 9.3236C12.1613 9.21608 12.2473 9.13543 12.3548 9.08167C12.4624 9.01715 12.5753 8.99027 12.6935 9.00102C12.8226 9.00102 12.9409 9.03328 13.0484 9.0978Z" />
	</svg>
);

export default VideoControlsPlayCircle;
